module.exports = __webpack_public_path__ + "static/media/in_between.138c6eba.svg";